// extracted by mini-css-extract-plugin
export var divider = "_gj-7";
export var itemsToggle = "_gj-8";
export var mergeModal = "_gj-1";
export var optionCard = "_gj-4";
export var radioGroup = "_gj-6";
export var radioOption = "_gj-0";
export var selected = "_gj-5";
export var shipmentOptions = "_gj-2";
export var tableOptions = "_gj-3";